export class TransactionSearch {
    constructor(
        public transactionIds?: number[],
        public lotIds?: string[],
        public statusIds?: string[],
        public gids?: string[],
        public unitIds?: string[],
        public lotStatus?: number,
        public designation?: string,
        public stockId?: string,
        public createdByUsername?: string,
        public transactionTypes?: number[],
        public transactionStatus?: number[],
        public notes?: string,
        public minAmount?: number,
        public maxAmount?: number,
        public createdDateFrom?: string,
        public createdDateTo?: string,
        public observationUnitId?: string[]) {
    }
}
